import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=fc81b020&scoped=true"
import script from "./documentation.vue?vue&type=script&lang=js"
export * from "./documentation.vue?vue&type=script&lang=js"
import style0 from "./documentation.vue?vue&type=style&index=0&id=fc81b020&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc81b020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc81b020')) {
      api.createRecord('fc81b020', component.options)
    } else {
      api.reload('fc81b020', component.options)
    }
    module.hot.accept("./documentation.vue?vue&type=template&id=fc81b020&scoped=true", function () {
      api.rerender('fc81b020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/help/documentation.vue"
export default component.exports